import React from "react";

const TicketNormalization = ({ row }) => {
  return <div>{row?.ticketsCount?.toLocaleString()}</div>;
};

export default TicketNormalization;
